import { render, staticRenderFns } from "./AzureQueue.vue?vue&type=template&id=c3abc770&"
import script from "./AzureQueue.vue?vue&type=script&lang=js&"
export * from "./AzureQueue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports